import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box } from '@gemini/core';
import { Breadcrumb as BaseBreadcrumb } from '@seo/breadcrumb';
import { MediumCta } from '@/entities/enums/MediumCta';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
import { getUrlWithMediumAttribute } from '@/helpers/tracking/tracking';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const Breadcrumb = ({ breadcrumbData }) => {
    const [isUser, setIsUser] = useState(null);
    const { t } = useShellTranslation();
    const countryName = t('breadcrumbs.multiple_levels.country');
    const items = breadcrumbData.items.map((item, index) => {
        return {
            ...item,
            name: index === 0 ? countryName : item.name,
        };
    });
    const links = breadcrumbData.links.map((link, index) => {
        const rawUrl = link.url
            ? getUrlWithMediumAttribute({
                url: link.url ?? '',
                cta: MediumCta.BREADCRUMB,
                originPlaceType: link.originPlaceType,
                destination: link.destinationPlaceType,
            })
            : undefined;
        const url = rawUrl ? appendEphemeralParam(rawUrl) : undefined;
        const shouldObfuscate = link.isObfuscated && isUser !== true;
        return {
            ...link,
            url: shouldObfuscate ? undefined : url,
            title: index === 0 ? countryName : link.title,
        };
    });
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsUser(window.isUser ?? false);
        }
    }, []);
    return (_jsxs(Box, { typography: "typography.body.12.regular", children: [_jsx(BaseBreadcrumb, { links: links, marginHorizontal: "0", paddingLeft: "0" }), _jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'BreadcrumbList',
                        itemListElement: items,
                    }, null, 4),
                } })] }));
};
